import Modal from "antd/es/modal/Modal";
import React, { useEffect, useState } from "react";
import style from "css/mypage.module.css";
import axios from "axios";
import { Button, QRCode } from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";
import { CloseOutlined, CopyOutlined, QrcodeOutlined } from "@ant-design/icons";
import CopyToClipboard from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";

function Mypagedetailpop(props) {
  const { t, i18n } = useTranslation();
  const closePop = () => {
    props.refresh();
    props.close();
  };
  const payload = useSelector((state) => state.user);
  const [scheduleinfo, setscheduleinfo] = useState({});
  const [dataload, setdataload] = useState(false);
  useEffect(() => {
    if (props.SCHEDULE_ID !== "") {
      let config = {
        params: {
          SCHEDULE_ID: props.SCHEDULE_ID,
        },
      };
      axios.get("/schedule/myscheduledetail", config).then((res) => {
        if (res.status === 200) {
          setscheduleinfo(res.data);
          setdataload(true);
        }
      });
    }
  }, [props.SCHEDULE_ID, props.open]);
  let today = new Date();
  const checkjoin = (now, start, end, make) => {
    let nowTime = moment(now);
    let startTime = moment(start);
    let endTime = moment(end);

    let diff = {
      month: moment.duration(startTime.diff(nowTime)).months(),
      day: moment.duration(startTime.diff(nowTime)).days(),
      hour: moment.duration(startTime.diff(nowTime)).hours(),
      minute: moment.duration(startTime.diff(nowTime)).minutes(),
      fin: moment.duration(endTime.diff(nowTime)).minutes(),
    };

    if (diff.fin < 0) {
      return "finish";
    } else {
      if (diff.month < 1 && diff.day < 1 && diff.hour < 1 && diff.minute < 30) {
        return true;
      } else {
        return false;
      }
    }
  };

  const offlinecheck = (now, start, end, make) => {
    let nowTime = moment(now);
    let startTime = moment(start);
    let endTime = moment(end);

    let diff = {
      month: moment.duration(startTime.diff(nowTime)).months(),
      day: moment.duration(startTime.diff(nowTime)).days(),
      hour: moment.duration(startTime.diff(nowTime)).hours(),
      minute: moment.duration(startTime.diff(nowTime)).minutes(),
      fin: moment.duration(endTime.diff(nowTime)).minutes(),
    };

    if (diff.fin < 0) {
      return "finish";
    } else {
      if (diff.month < 1 && diff.day < 1 && diff.hour < 1 && diff.minute < 1) {
        return false;
      } else {
        return true;
      }
    }
  };
  const dispatch = useDispatch();

  const handleDelete = () => {
    let config = {
      params: {
        PROCESS_TYPE: "D",
        CALENDAR_TYPE: props.PAGE_TYPE === "calendar" ? "MY" : "FULL",
        SCHEDULE_ID: scheduleinfo.SCHEDULE_ID,
        SCHEDULE_TYPE: scheduleinfo.SCHEDULE_TYPE,
        TITLE: scheduleinfo.TITLE,
        RECORD_YN: scheduleinfo.RECORD_YN,
        START_TIME: dayjs(scheduleinfo.START_DATETIME).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        END_TIME: dayjs(scheduleinfo.END_DATETIME).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      },
    };

    axios
      .delete("/schedule/reserve", config)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
          closePop();
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
    // closePop();
  };

  const handleUpdate = () => {
    props.isOpenRes({
      PROCESS_TYPE: "U",
      SCHEDULE_ID: scheduleinfo.SCHEDULE_ID,
      SCHEDULE_TYPE: scheduleinfo.SCHEDULE_TYPE,
      TITLE: scheduleinfo.TITLE,
      RECORD_YN: scheduleinfo.RECORD_YN,
      START_TIME: dayjs(scheduleinfo.START_DATETIME).format(
        "YYYY-MM-DD HH:mm:ss"
      ),
      END_TIME: dayjs(scheduleinfo.END_DATETIME).format("YYYY-MM-DD HH:mm:ss"),
      PARTICIPANT_LIST: scheduleinfo.participantlist,
      ENDPOINT_LIST: scheduleinfo.endpointlist,
      CONTENTS: scheduleinfo.CONTENTS,
      OPEN_YN: scheduleinfo.OPEN_YN,
      MAIL_YN: scheduleinfo.MAIL_YN,
      MEETING_PW: scheduleinfo.MEETING_PW,
      ATTACHMENT_LIST: scheduleinfo.attachmentlist,
    });
    closePop();
  };
  const handleRe = () => {
    props.isOpenRes({
      PROCESS_TYPE: "C",
      SCHEDULE_ID: scheduleinfo.SCHEDULE_ID,
      SCHEDULE_TYPE: scheduleinfo.SCHEDULE_TYPE,
      TITLE: scheduleinfo.TITLE,
      RECORD_YN: scheduleinfo.RECORD_YN,
      START_TIME: getReserveDateTime(new Date(), 0),
      END_TIME: getReserveDateTime(new Date(), 30),
      PARTICIPANT_LIST: scheduleinfo.participantlist,
      ENDPOINT_LIST: scheduleinfo.endpointlist,
      CONTENTS: scheduleinfo.CONTENTS,
      OPEN_YN: scheduleinfo.OPEN_YN,
      MAIL_YN: scheduleinfo.MAIL_YN,
      MEETING_PW: scheduleinfo.MEETING_PW,
      ATTACHMENT_LIST: scheduleinfo.attachmentlist,
    });
    closePop();
  };

  const downloadFile = (params) => {
    axios
      .post("/schedule/downloadFile", params, { responseType: "blob" })
      .then((response) => response.data)
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", params.ORI_FILE_NM);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };

  function getReserveDateTime(date, duration) {
    const minutes = date.getMinutes();
    const ceiledMinutes = Math.ceil(minutes / 10) * 10;
    const hours = date.getHours() + Math.floor(ceiledMinutes / 60);
    const ceiledMinutesString = String(ceiledMinutes % 60).padStart(2, "0");
    const ceiledTime = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      hours,
      ceiledMinutesString
    );
    const dateTime = new Date(ceiledTime.getTime() + duration * 60000);

    const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const clientDateString = new Date().toLocaleString("en-US", {
      timeZone: clientTimeZone,
    });
    const clientDate = new Date(clientDateString);
    const offsetInMinutes = clientDate.getTimezoneOffset();
    const TIME_ZONE = offsetInMinutes * 60 * 1000 * -1;

    const formattedDateTime = new Date(dateTime.getTime() + TIME_ZONE)
      .toISOString()
      .replace("T", " ")
      .slice(0, -5);

    return formattedDateTime;
  }

  const [openPopqr, setopenPopqr] = useState(false);
  const closePopqr = () => {
    setopenPopqr(false);
  };

  const datetimeConverter = (value) => {
    if (i18n.language === "en-US") {
      return moment(value).locale("en").format("MMMM D, YYYY (ddd) - hh:mm A");
    } else {
      return moment(value).locale("ko").format("YYYY-MM-DD (dd) - a hh:mm");
    }
  };
  const systemtype = useSelector((state) => state.system.isOnline);
  return (
    <div className="mypagedetailpopup">
      <Modal
        className={style.detailpopup} //모달 ClassName
        open={props.open}
        onCancel={closePop}
        footer={null}
        width="460px"
        centered
        closeIcon={
          <CloseOutlined
            style={{
              color: "#121212",
              border: "1px solid #a4a4a4",
              borderRadius: "5px",
              padding: "5px",
              fontSize: "24px",
              top: "20px !important",
              right: "30px !important",
            }}
          />
        }
      >
        <Modal
          centered
          className={style.qrpop_full} //모달 ClassName
          open={openPopqr}
          onCancel={closePopqr}
          footer={null}
          width="auto"
        >
          <QRCode
            errorLevel="H"
            value="https://www.riv-tech.co.kr/neat"
            //icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.png"
            //icon="c:\Users\hmkim\Desktop\neat.png"
            icon={process.env.REACT_APP_CLIENT_URL + "neat2.png"}
            iconSize={130}
            size={800}
          />
          <div
            style={{ fontSize: "22px", textAlign: "center", marginTop: "5px" }}
          >
            MEETING URL : {scheduleinfo.MEETING_URL}
          </div>
        </Modal>
        <div className={style.detailpop_body}>
          <div className={style.detailpop_header}>
            {t("LABEL.TITLE.MEETING_DETAILS")}
          </div>
          <div className={style.detailpop_title_bar}></div>
          <div className={style.detailpop_title}>{scheduleinfo.TITLE}</div>
          <div className={style.detailpop_content}>
            <div className={style.detailpop_content_line1}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_START")}
              </div>
              <div className={style.detailpop_content_body}>
                {datetimeConverter(scheduleinfo.START_DATETIME)}
              </div>
            </div>
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_END")}
              </div>
              <div className={style.detailpop_content_body}>
                {datetimeConverter(scheduleinfo.END_DATETIME)}
              </div>
            </div>
            {/* <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>장소</div>
              <div className={style.detailpop_content_body}>장소장소장소</div>
            </div> */}
            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_HOST")}
              </div>
              <div className={style.detailpop_content_body}>
                {scheduleinfo.EMAIL}
              </div>
            </div>
            <div className={style.detailpop_content_line3}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_PLACE")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {dataload ? (
                  scheduleinfo.ENDPOINTLIST.length > 3 ? (
                    scheduleinfo.endpointlist
                      .map((data) => data.ENDPOINT_NM)
                      .join(", ")
                  ) : (
                    <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                  )
                ) : (
                  <div>{t("LABEL.NO_MEETING_ROOM")}</div>
                )}
              </div>
            </div>
            <div className={style.detailpop_content_line3}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_PTCP")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {dataload ? (
                  scheduleinfo.PARTILIST.length > 3 ? (
                    scheduleinfo.participantlist.map((data, index) => (
                      <div key={index}>
                        {data.MEMBER_NM} {data.EMAIL}
                      </div>
                    ))
                  ) : (
                    <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                  )
                ) : (
                  <div>{t("LABEL.NO_MEETING_PTCP")}</div>
                )}
              </div>
            </div>

            <div className={style.detailpop_content_line}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.ATTACHMENT")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {dataload ? (
                  scheduleinfo.FILE_INFO.length > 3 ? (
                    (scheduleinfo.attachmentlist || []).map((data, index) => (
                      <div key={index}>
                        <span
                          onClick={() => downloadFile(data)}
                          className={style.detailpop_content_aTag}
                        >
                          {data.ORI_FILE_NM}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div>{t("LABEL.NO_ATTACHMENT")}</div>
                  )
                ) : (
                  <div>{t("LABEL.NO_ATTACHMENT")}</div>
                )}
              </div>
            </div>

            <div className={style.detailpop_content_line1}>
              <div className={style.detailpop_content_header}>
                {t("LABEL.MEETING_CONTENT")}
              </div>
              <div className={style.detailpop_content_body2 + " scrollbar"}>
                {scheduleinfo.CONTENTS}
              </div>
            </div>
            {systemtype === false ? (
              ""
            ) : (
              <div className={style.detailpop_content_line2}>
                <div className={style.detailpop_content_header_button_area}>
                  {t("LABEL.MEETING_LINK")}
                </div>
                <div
                  className={style.detailpop_content_body}
                  style={{ gap: "5px" }}
                >
                  <CopyToClipboard
                    className={style.detailpop_content_button + " cursor"}
                    text={scheduleinfo.MEETING_URL}
                    onCopy={() => {
                      const obj = {
                        title: t("MESSAGE.NOTIFICATION"),
                        content: t("MESSAGE.COPY_COMPLETE"),
                        submitEventHandler: () => {
                          dispatch(closeAlert());
                        },
                      };
                      dispatch(openAlert(obj));
                      return;
                    }}
                  >
                    <div>
                      {t("BTN.LINK_COPY")}
                      <CopyOutlined
                        style={{
                          marginLeft: "3px",
                          fontSize: "15px",
                        }}
                      />
                    </div>
                  </CopyToClipboard>
                  <div
                    className={style.detailpop_content_button + " cursor"}
                    onClick={() =>
                      // {
                      //   const obj = {
                      //     title: "QR코드로 입장",
                      //     content: (
                      //       <QRCode
                      //         errorLevel="H"
                      //         value={scheduleinfo.MEETING_URL}
                      //         icon="https://demo.riv-tech.co.kr/allplace/img/mypage/logo.svg"
                      //         size={460}
                      //       />
                      //     ),
                      //     submitEventHandler: () => {
                      //       dispatch(closeAlert());
                      //     },
                      //   };
                      //   dispatch(openAlert(obj));
                      //   return;
                      // }
                      setopenPopqr(true)
                    }
                  >
                    {t("BTN.QR_CODE")}
                    <QrcodeOutlined
                      style={{ marginLeft: "3px", fontSize: "15px" }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <div>
            {dataload ? (
              scheduleinfo.INPUT_ID === payload.id ? (
                scheduleinfo.SCHEDULE_TYPE === "CD0205" ? (
                  offlinecheck(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    true
                  ) === true ? (
                    <div className={style.detailpop_btnline3}>
                      <Button
                        type="primary"
                        className={style.mydetail_update_btn}
                        onClick={() => handleUpdate()}
                      >
                        {t("BTN.MODIFY")}
                      </Button>
                      <Button
                        type="primary"
                        className={style.mydetail_delete_btn}
                        onClick={() => {
                          const obj = {
                            title: t("MESSAGE.NOTIFICATION"),
                            content: t("MESSAGE.DELETE_SCD"),
                            submitEventHandler: () => {
                              handleDelete();
                              dispatch(closeAlert());
                            },
                          };
                          dispatch(openConfirm(obj));
                        }}
                      >
                        {t("BTN.DELETE")}
                      </Button>
                    </div>
                  ) : offlinecheck(
                      today,
                      scheduleinfo.START_DATETIME,
                      scheduleinfo.END_DATETIME,
                      true
                    ) === false ? (
                    <div className={style.detailpop_btnline1}>
                      <div
                        className={style.detailpop_gray_big_btn + " cursor"}
                        onClick={() => handleRe()}
                      >
                        {t("BTN.RESERVE_AGAIN")}
                      </div>
                    </div>
                  ) : (
                    <div className={style.detailpop_btnline1}>
                      <div
                        className={style.detailpop_gray_big_btn + " cursor"}
                        onClick={() => handleRe()}
                      >
                        {t("BTN.RESERVE_AGAIN")}
                      </div>
                    </div>
                  )
                ) : checkjoin(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    true
                  ) === true ? (
                  <div className={style.detailpop_btnline1}>
                    <Button
                      type="primary"
                      style={{
                        height: "45px",
                        width: "198px",
                        fontWeight: "bold",
                      }}
                      onClick={() => window.open(scheduleinfo.MEETING_URL)}
                    >
                      {t("BTN.ENTER_MEETING")}
                    </Button>
                  </div>
                ) : checkjoin(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    true
                  ) === false ? (
                  <div className={style.detailpop_btnline3}>
                    <Button
                      type="primary"
                      className={style.mydetail_update_btn}
                      onClick={() => handleUpdate()}
                    >
                      {t("BTN.MODIFY")}
                    </Button>
                    <Button
                      type="primary"
                      className={style.mydetail_delete_btn}
                      onClick={() => {
                        const obj = {
                          title: t("MESSAGE.NOTIFICATION"),
                          content: t("MESSAGE.DELETE_SCD"),
                          submitEventHandler: () => {
                            handleDelete();
                            dispatch(closeAlert());
                          },
                        };
                        dispatch(openConfirm(obj));
                      }}
                    >
                      {t("BTN.DELETE")}
                    </Button>
                    {/* <div
                      className={style.detailpop_gray_big_btn}
                      style={{ cursor: "not-allowed" }}
                    >
                      {t("BTN.ENTER_MEETING")}
                    </div> */}
                  </div>
                ) : (
                  <div className={style.detailpop_btnline1}>
                    <div
                      className={style.detailpop_gray_big_btn + " cursor"}
                      onClick={() => handleRe()}
                    >
                      {t("BTN.RESERVE_AGAIN")}
                    </div>
                  </div>
                )
              ) : scheduleinfo.SCHEDULE_TYPE === "CD0205" ? (
                <div>
                  {offlinecheck(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    false
                  ) === true ? (
                    <></>
                  ) : offlinecheck(
                      today,
                      scheduleinfo.START_DATETIME,
                      scheduleinfo.END_DATETIME,
                      false
                    ) === false ? (
                    <></>
                  ) : (
                    <div className={style.detailpop_btnline1}>
                      <div className={style.detailpop_gray_big_btn + " cursor"}>
                        {t("BTN.MEETING_CLOSED")}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div>
                  {checkjoin(
                    today,
                    scheduleinfo.START_DATETIME,
                    scheduleinfo.END_DATETIME,
                    false
                  ) === true ? (
                    <div className={style.detailpop_btnline1}>
                      <Button
                        type="primary"
                        style={{
                          height: "45px",
                          width: "198px",
                          fontWeight: "bold",
                        }}
                        onClick={() => window.open(scheduleinfo.MEETING_URL)}
                      >
                        {t("BTN.ENTER_MEETING")}
                      </Button>
                    </div>
                  ) : checkjoin(
                      today,
                      scheduleinfo.START_DATETIME,
                      scheduleinfo.END_DATETIME,
                      false
                    ) === false ? (
                    <div className={style.detailpop_btnline1}>
                      <div className={style.detailpop_gray_big_btn + " cursor"}>
                        {t("BTN.ENTER_MEETING")}
                      </div>
                    </div>
                  ) : (
                    <div className={style.detailpop_btnline1}>
                      <div className={style.detailpop_gray_big_btn + " cursor"}>
                        {t("BTN.MEETING_CLOSED")}
                      </div>
                    </div>
                  )}
                </div>
              )
            ) : (
              <div />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default Mypagedetailpop;
